import { FilterOutlineIcon } from './FilterOutlineIcon';

/**
 * author: Austin Andrews
 * id 524BE3DE-F5C8-4E2E-A329-8480136DCBDB
 * name filter-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-outline.svg
 * tags
 */
export const FunnelOutlineIcon = FilterOutlineIcon;
export default FunnelOutlineIcon